<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>操作出库</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <div v-if="!showDetails" class="storedialog load-dialog">
      <el-button link @click="showDetails = true" class="download" style="margin:0 auto;">
        方式1：手动填写/扫码货品批次，操作出库。
      </el-button>
      <hr>

      <span class="download">
        <el-upload v-loading="loading" class="upload-box" ref="upload" action="#" :on-change="handleChange"
          :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList" :http-request="submitUpload"
          :auto-upload="true" :limit="1" style="display:inline-flex;margin-right: 0px;">
          方式2：上传表格，批量操作出库。
        </el-upload>
        <a target="_blank" :href="templateUrl">下载模板.xlsx </a>
      </span>

      <el-upload v-loading="loading" class="upload-box" ref="upload" action="#" :on-change="handleChange"
        :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList" :http-request="submitUpload"
        :auto-upload="true" drag :limit="1" style="width:60%; max-width: 800px; margin:10px auto;">
        <el-icon style="font-size:3em;">
          <UploadFilled />
        </el-icon>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip">
          注：Excel表格里的填写项请严格按照模板内容进行填写
        </div>
      </el-upload>

      <div class="errtext" v-for="(value, key) in resList" :key="key">
        <i class="el-icon-error"></i> {{ key + " " + value }}
      </div>
    </div>

    <el-form v-if="showDetails" :model="querys" ref="querys" label-width="90px" class="search-form">
      <el-row>
        <el-form-item label="出库类型" prop="billType">
          <el-col>
            <el-select v-model="form.billType" @change="changeBillType($event, dict.billTypes)" placeholder="请选择出库类型"
              style="width: 150px">
              <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-col>
            <!-- <el-cascader v-model="companyID" :options="companys" /> -->
            <el-tree-select ref="companys" v-model="form.companyID" :data="companys" check-strictly
              :render-after-expand="false" style="min-width: 200px;" />
          </el-col>
        </el-form-item>
        <el-form-item label="出库单号">
          <el-col>
            <el-input v-model="form.billCode" autocomplete="off" disabled style="width: 150px" placeholder="自动生成">
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="出库时间">
          <el-col>
            <el-input v-model="form.billDate" autocomplete="off" disabled style="width: 160px" placeholder="自动生成">
            </el-input>
          </el-col>
        </el-form-item>

        <!-- <el-form-item label="出网编号">
        <el-col>
          <el-input v-model="form.netCode" autocomplete="off" style="width: 130px" placeholder="请填写出网编号">
          </el-input>
        </el-col>
      </el-form-item> -->
      </el-row>
    </el-form>

    <div v-if="showDetails" class="billsdetial">
      <div class="table tableprint" ref="print" id="print-panel">
        <el-table :data="tableData" stripe border width="1200" size="small">
          <el-table-column type="index" align="center" label="序号" width="50"> </el-table-column>

          <el-table-column label="批次号" width="120">
            <template #default="scope">
              <el-input v-model="scope.row.brandSerialCode" autocomplete="off" size="small" placeholder=""> </el-input>
            </template>
          </el-table-column>

          <el-table-column label="库房" width="105">
            <template #default="scope">
              <el-select v-model="scope.row.storeCode" placeholder="请选择库房" size="small" style="width:100%">
                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="storeCode" label="库房" width="120">
          </el-table-column> -->
          <el-table-column prop="channel" label="渠道" width="80"> </el-table-column>
          <el-table-column prop="brandName" label="供应商" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="detailName" label="名称" width="120" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="brandModelCode" label="品牌款号" width="100" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="detailCode" label="系统款号" width="150" show-overflow-tooltip> </el-table-column>
          <el-table-column label="数量" width="80">
            <template #default="scope">
              <el-input-number v-model="scope.row.stockNumber" :min="0.01" :max="999" size="small"
                controls-position="right" style="width:100%"></el-input-number>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="weight" width="60" label="克重"> </el-table-column> -->
          <el-table-column label="克重范围" width="80" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.weight }} {{ scope.row.weightMax ? (' - ' + scope.row.weightMax) : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="unitName" label="规格" width="80" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="fittingName" label="辅料" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
        </el-table>
        <el-row type="flex" class="inputfeed" justify="center" gutter="20" style="margin-top: 10px;">
          <el-col :span="5">
            操作：
            <el-input size="mini" v-model="form.handoverName" style="width: 60%" autocomplete="on"></el-input>
          </el-col>
          <el-col :span="5">
            交接：
            <el-input size="mini" v-model="form.reviewerName" style="width: 60%" autocomplete="on"></el-input>
          </el-col>
          <el-col :span="5">
            复核：
            <el-input size="mini" v-model="form.operatorName" style="width: 60%" autocomplete="on"></el-input>
          </el-col>
          <el-col :span="5">
            财务：
            <el-input size="mini" v-model="form.financerName" style="width: 60%" autocomplete="on"></el-input>
          </el-col>
        </el-row>
      </div>
      <div class="billsbutton" style="text-align: center;">
        <el-button type="primary" @click="showAddDialog = true">
          <el-icon>
            <CirclePlus />
          </el-icon>
          &nbsp;输入/扫码 出库货品 </el-button>
        <el-button type="">
          <el-upload ref="upload" action="#" :on-change="handleChange" :on-remove="handleRemove"
            :on-exceed="handleExceed" :file-list="fileList" :http-request="submitUpload" :auto-upload="true" :limit="1"
            style="display:inline-flex;margin-right: 0px;">
            <el-icon>
              <RefreshLeft />
            </el-icon>
            &nbsp;重新上传表格
          </el-upload>
        </el-button>

        <el-button @click="onprint"> 打印 <i class="el-icon-printer"> </i> </el-button>
        <el-button @click="preExport()"> 导出出库表 <i class="el-icon-arrow-right"> </i> </el-button>
        <el-button type="primary" @click="save()"> 保存出库 <i class="el-icon-arrow-right"> </i> </el-button>
      </div>
    </div>

    <!-- 新增出库明细弹框 -->
    <el-dialog title="新增出库明细" v-model="showAddDialog" style="max-width:1200px; width: 100%;" destroy-on-close>
      <el-form :model="searchForm" label-width="110px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="货品批次号">
              <el-input v-model="searchForm.serialCode" placeholder="请输入批次号" clearable
                @keyup.enter="searchStock"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="系统款号">
              <el-input v-model="searchForm.detailCode" placeholder="请输入系统款号" clearable
                @keyup.enter="searchStock"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品牌款号">
              <el-input v-model="searchForm.brandModelCode" placeholder="请输入品牌款号" clearable
                @keyup.enter="searchStock"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属公司">
              <el-tree-select ref="companys" v-model="form.companyID" :data="companys" clearable check-strictly
                :render-after-expand="false" style="min-width: 200px;" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="库房">
              <el-select v-model="searchForm.storeCode" placeholder="请选择库房" clearable style="width:100%">
                <el-option v-for="item in dict.stores" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="渠道">
              <el-select v-model="searchForm.channel" placeholder="请选择渠道" clearable style="width:100%">
                <el-option v-for="item in dict.channels" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align:center;">
            <el-button type="primary" icon="Search" @click="searchStock" :loading="searchLoading">查询货品</el-button>
            <el-button @click="resetSearchForm">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-divider></el-divider>

      <!-- 查询结果表格 -->
      <el-table :data="searchResults" border style="width: 100%; margin-top: 10px;" size="small" max-height="400"
        v-loading="searchLoading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="serialCode" label="批次号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailCode" label="系统款号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="detailName" label="货品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeCode" label="库房" width="70" align="center"></el-table-column>
        <el-table-column prop="channel" label="渠道" width="70" align="center"></el-table-column>
        <el-table-column prop="stockDate" label="入库时间" width="100" align="center">
          <template #default="scope">
            {{ (scope.row.stockDate || '').split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column prop="stockRemain" label="库存数量" width="70" align="right"></el-table-column>
        <el-table-column label="操作" width="80" align="center" fixed="right">
          <template #default="scope">
            <el-button type="primary" link size="small" @click="addToList(scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showAddDialog = false">取消</el-button>
        </span>
      </template>
    </el-dialog>
  </el-card>
</template>
<script>
import printJS from "print-js";

import { fetchBillCode, billPreOutExport, submitBillOut, fetchGroupBySerialCode } from "@/api/stock";
import { uploader, outReviewer } from "@/api/subupload";
export default {
  name: "outstore",
  emits: ["outDialogWidth"],
  data() {
    return {
      templateUrl: process.env.VUE_APP_BASEURL + "/static/template/stockout.xlsx",
      fileList: [],
      loading: false,
      resList: {},
      dataId: "",
      tableData: [],
      showDetails: false,

      dict: {
        brands: [],
        billTypes: [],
        stores: [],
        channels: [],
      },

      // 新增明细弹框相关
      showAddDialog: false,
      searchLoading: false,
      searchResults: [],
      searchForm: {
        serialCode: '',
        detailCode: '',
        brandModelCode: '',
        storeCode: '',
        channel: '',
      },

      //companyID: [],
      form: {
        billType: "", //出库类型
        storeCode: "", //出库库房
        billDate: "", //时间
        billCode: "", //出库单据号
        netCode: "", //出、入网单
        handoverName: "",
        reviewerName: "",
        operatorName: "",
        financerName: "",
        companyID: ''
      },
      companys: []
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    //添加文件事件
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    //删除文件事件
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    //超出个数事件
    handleExceed(file, fileList) {
      this.$message({
        message: "每次只能上传一个文件",
        type: "warning",
      });
    },
    //上传操作
    submitUpload(file) {
      this.loading = true;
      var dataList = new FormData();
      dataList.append(file.file.name, file.file);
      dataList.append("fileType", "excel");
      dataList.append("dataType", "BillOut");
      this.$refs.upload.clearFiles();

      uploader(dataList)
        .then((res) => {
          if (res.code === 200) {
            this.$message({ message: "上传成功", type: "success" });
            this.dataId = res.data[0].id;
          } else {
            this.$message.error("上传失败，请重试");
          }
        })
        .then(() => {
          this.loading = false;
          outReviewer(this.dataId).then(
            (res) => {
              this.$message(res.content || "上传失败，请检查后重试");
              if (res.code === 200) {
                this.tableData = Object.values({ ...res.data });
                this.showDetails = true;
                this.$emit("outDialogWidth", "80%");
              }
            },
            (err) => {
              console.log(err);
              //this.$message.error(err.content || "上传失败，请检查后重试");
              if (err.data && err.data instanceof Object) {
                this.resList = err.data;
              }
            }
          );
        });

      this.fileList = [];
    },
    //获取单据编号
    changeBillType(value, options) {
      let items = options.filter(function (item) {
        return item.name == value;
      });
      if (items && items.length > 0) {
        let that = this;
        fetchBillCode({
          billType: items[0].value,
          prev: items[0].attribute,
        }).then((res) => {
          that.form.billCode = res.data + "-" + that.tableData.length;
          that.form.billDate = that.$util.fmtDate(new Date());
        });
      }
    },
    //打印
    onprint() {
      console.log(this.tableData)
      let printData = [];

      let normalSum = 0; let fitSum = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        let row = this.tableData[i];
        if (row.detailName.indexOf('[辅料]') > -1)
          fitSum++;
        else
          normalSum++;

        printData.push({
          '序号': (i + 1),
          '批次号': (row.brandSerialCode || ''),
          '库房': row.storeCode,
          '渠道': row.channel,
          '供应商': row.brandName,
          '名称': (row.detailName || '').length > 13 ? (row.detailName.substr(0, 13) + '…') : (row.detailName || ''),
          '品牌款号': (row.brandModelCode || '无'),
          '数量': row.stockNumber,
          '克重/规格': (row.weight || '无') + "/" + (row.unitName || '无'),
          '辅料': (row.fittingName || ''),
          '备注': (row.remark || ''),
        });
      }

      printJS({
        header: '<h3 class="">预出库单(正常货品 ' + normalSum + ' 件，辅料 ' + fitSum + ' 件)</h3>',
        printable: printData,
        properties: ['序号', '批次号', '库房', '渠道', '供应商', '名称', '品牌款号', '数量', '克重/规格', '辅料', '备注'],
        type: 'json',
        gridHeaderStyle: 'font-size:0.8em;border: 1px solid #ccc;white-space:nowrap',
        gridStyle: 'font-size:0.8em;border: 1px solid #ccc;text-align:center;white-space:nowrap'
      })
    },
    preExport() {
      let that = this;
      if (this.tableData.length <= 0) {
        this.$message({ message: "请导入至少一条数据", type: "warning", });
        return;
      }
      if (this.form.billType == "" || this.form.billDate == "" || this.form.billCode == "") {
        this.$message({
          message: "必填信息不可为空",
          type: "warning",
        });
        return;
      }

      if (this.form.companyID.length == 0) {
        this.$message({ message: "请选择所属公司", type: "warning", });
        return;
      }
      //this.form.companyID = this.companyID[this.companyID.length - 1];

      billPreOutExport({ bill: this.form, bounds: this.tableData }).then((res) => {
        if (res.code == 200)
          window.location.href = process.env.VUE_APP_BASEURL + res.data;
      });
    },
    //出库
    save() {
      let that = this;
      if (this.tableData.length <= 0) {
        this.$message({ message: "请导入至少一条数据", type: "warning", });
        return;
      }
      if (this.form.billType == "") {
        this.$message({ message: "请选择本次出库类型", type: "warning", });
        return;
      }

      if (this.form.companyID.length == 0) {
        this.$message({ message: "请选择所属公司", type: "warning", });
        return;
      }
      //this.form.companyID = this.companyID[this.companyID.length - 1];

      if (this.form.billType == "" || this.form.billDate == "" || this.form.billCode == "") {
        this.$message({ message: "必填信息不可为空", type: "warning", });
        return;
      }

      submitBillOut({ bill: this.form, bounds: this.tableData }).then((res) => {
        that.$message({ type: res.type, message: res.content, });
        //this.$emit("outDialogWidth", "");
        if (res.code == 200) {
          that.$router.go(-1);
        }
      });
    },

    // 重置搜索表单
    resetSearchForm() {
      this.searchForm = {
        serialCode: '',
        detailCode: '',
        brandModelCode: '',
        storeCode: '',
        channel: '',
      };
      this.searchResults = [];
    },

    // 查询库存货品
    searchStock() {
      if (!this.searchForm.serialCode && !this.searchForm.detailCode &&
        !this.searchForm.storeCode && !this.searchForm.channel && !this.searchForm.companyID) {
        this.$message.warning('请至少填写一个查询条件（推荐填写批次号进行精确查询）');
        return;
      }

      this.searchLoading = true;

      const serialCodes = [];
      if (this.searchForm.serialCode) {
        const codes = this.searchForm.serialCode.split(',').map(code => code.trim()).filter(code => code);
        serialCodes.push(...codes);
      }

      fetchGroupBySerialCode(
        serialCodes,
        this.form.companyID || '',
        this.searchForm.detailCode || '',
        this.searchForm.storeCode || '',
        this.searchForm.channel || '',
        this.searchForm.brandModelCode || ''
      ).then((res) => {
        this.searchLoading = false;
        if (res.code === 200) {
          let queryResults = (res.data || []).filter(item => (item.stockRemain || 0) > 0);
          if (queryResults.length === 0) {
            this.$message.info('未找到符合条件的库存货品');
          } else {
            // 清空搜索表单
            this.searchForm = {
              serialCode: '',
              detailCode: '',
              brandModelCode: '',
              storeCode: '',
              channel: '',
            };
            // 追加到搜索结果，而不是替换
            this.searchResults = this.searchResults.concat(queryResults);
            this.form.companyID = queryResults[0].companyID;
          }
        } else {
          this.$message.error(res.content || res.message || '查询失败');
        }
      }).catch((error) => {
        this.searchLoading = false;
        console.error('查询库存失败:', error);
        this.$message.error('查询失败，请检查查询条件或稍后重试');
      });
    },

    // 添加到出库明细列表
    addToList(row) {
      const exists = this.tableData.some(item =>
        item.id === row.id
      );

      if (exists) {
        this.$message.warning('该货品已在列表中，请勿重复添加');
        return;
      }

      // 添加到待出库明细
      this.tableData.push({
        id: row.id,
        brandSerialCode: row.serialCode,
        storeCode: row.storeCode,
        channel: row.channel,
        brandName: row.brandName,
        detailName: row.detailName,
        brandModelCode: row.brandModelCode,
        detailCode: row.detailCode,
        stockNumber: row.stockRemain,
        weight: row.weight,
        weightMax: row.weightMax,
        unitName: row.unitName,
        fittingName: row.fittingName,
        remark: '',
      });

      this.$message.success('添加成功');

      // 从搜索结果中移除已添加的项
      this.searchResults = this.searchResults.filter(item =>
        item.id !== row.id
      );
    },
  },
  mounted() {
    this.$kaung.dictionary("stock", "brand").then((res) => { this.dict.brands = res; });
    this.$kaung.dictionary("stock", "outbound").then((res) => { this.dict.billTypes = res; });
    this.$kaung.dictionary("stock", "store").then(res => this.dict.stores = res);
    this.$kaung.dictionary("stock", "channel").then(res => this.dict.channels = res);

    this.$kaung.companys().then((res) => {
      this.companys = res;
    });
  },
};
</script>
<style lang="less">
.storedialog {
  width: 100%;
  height: 100%;
  min-width: 400px;
  background: #fff;
  text-align: center;

  .download {
    font-size: 20px;
    display: block;
    padding: 20px 0;
  }

  .errtext {
    color: red;
    line-height: 30px;
  }
}
</style>